import Vue from "vue";
import { common } from "@/utilities";

Vue.filter("date", (value) => {
  if (!value) return "";
  return common.gregorianToJalali(value, "date");
});

Vue.filter("dateTime", (value) => {
  if (!value) return "";
  return common.gregorianToJalali(value, "dateTime");
});
